import { 
  Coins, 
  TriangleAlert, 
  PackageCheck,
  PackageX, 
  FolderTree, 
  AlertOctagon
} from 'lucide-react';
import type { InventoryStats } from '../types/inventoryList.types';
import { formatCompactCurrency } from '@/utils/format';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';

interface InventoryKpiGridProps {
  stats: InventoryStats;
  isLoading?: boolean;
}

export function InventoryKpiGrid({ stats, isLoading }: InventoryKpiGridProps) {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng giá trị tồn',
      value: formatCompactCurrency(stats.totalValue, ''),
      suffix: 'VNĐ',
      icon: Coins,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: '+5.2%',
      chartColor: 'bg-blue-500',
      chartData: [40, 30, 50, 40, 60, 80, 100]
    },
    {
      title: 'Vật tư sắp hết',
      value: stats.lowStockCount,
      suffix: 'SP',
      icon: TriangleAlert,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: '-2.4%',
      chartColor: 'bg-amber-500',
      chartData: [80, 70, 90, 60, 50, 40, 30] // Going down is good for this metric
    },
    {
      title: 'Vật tư hết hàng',
      value: stats.outOfStockCount,
      suffix: 'SP',
      icon: AlertOctagon,
      color: 'text-rose-600',
      bg: 'bg-rose-50',
      trend: 'down',
      trendValue: 'Cần chú ý',
      chartColor: 'bg-rose-500',
      chartData: [20, 30, 25, 40, 50, 45, 60] // Illustrative history
    },
    {
      title: 'Đang hoạt động',
      value: stats.activeCount,
      suffix: 'SP',
      icon: PackageCheck,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Ổn định',
      chartColor: 'bg-emerald-500',
      chartData: [80, 85, 90, 85, 95, 90, 100]
    },
    {
      title: 'Danh mục vật tư',
      value: stats.totalItems,
      suffix: 'SKU',
      icon: FolderTree,
      color: 'text-violet-600',
      bg: 'bg-violet-50',
      trend: 'up',
      trendValue: 'Tổng quan',
      chartColor: 'bg-violet-500',
      chartData: [100, 100, 100, 100, 100, 100, 100] // Flat/stable
    },
    {
      title: 'Ngưng sử dụng',
      value: stats.inactiveCount,
      suffix: 'SP',
      icon: PackageX,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
      trend: 'neutral',
      trendValue: 'Đã khóa',
      chartColor: 'bg-slate-400',
      chartData: [10, 10, 15, 10, 12, 10, 15]
    },
  ];

  return <KpiGrid kpis={kpis} isLoading={isLoading} />;
}
